<template>
  <fragment>
    <g
      id="Eyebrow_type_A-8-3-12"
      v-if="data.value === 'type-12' && data.position === 'b'"
    >
      <g :fill="data.color">
        <path
          d="m176.49,150.43l2.17-4c.17-.27.43-.41.63-.36l30.52,1.81c.21.05.49.22.57.34l8.45,12.12c.42.51-.05,1.12-.67.97l-41.14-9.93c-.41-.1-.63-.56-.54-.95Z"
        />
        <path
          d="m176.51,150.38l.5-4.24c.05-.58.96-.57,1,0,0,0,.5,4.25.5,4.25.12,1.48-2.14,1.47-2-.01h0Z"
        />
        <path
          d="m174.4,149.87l.49-3.89c.06-.57.94-.57,1,0,0,0,.51,3.89.51,3.9.14,1.5-2.15,1.49-2,0h0Z"
        />
        <path
          d="m221.29,161.98c-.16,0-.31-.08-.41-.22-.81-1.17-1.61-2.39-2.41-3.61-2.14-3.26-4.35-6.62-6.93-9.44-.19-.2-.17-.52.03-.71.2-.19.52-.17.71.03,2.63,2.87,4.87,6.27,7.03,9.56.8,1.21,1.59,2.42,2.4,3.59.16.23.1.54-.13.7-.09.06-.18.09-.28.09Z"
        />
        <path
          d="m223.96,162.22c-.17,0-.34-.09-.43-.25-2.72-4.6-6.89-10.11-9.64-13.44-.18-.21-.15-.53.07-.7.21-.18.53-.15.7.07,2.77,3.35,6.98,8.92,9.73,13.56.14.24.06.54-.18.69-.08.05-.17.07-.25.07Z"
        />
        <path
          d="m143.68,150.43l-2.17-4c-.17-.27-.43-.41-.63-.36l-30.52,1.81c-.21.05-.49.22-.57.34l-8.45,12.12c-.42.51.05,1.12.67.97l41.14-9.93c.41-.1.63-.56.54-.95Z"
        />
        <path
          d="m143.66,150.38l-.5-4.24c-.05-.58-.96-.57-1,0,0,0-.5,4.25-.5,4.25-.12,1.48,2.14,1.47,2-.01h0Z"
        />
        <path
          d="m145.77,149.87l-.49-3.89c-.06-.57-.94-.57-1,0,0,0-.51,3.89-.51,3.9-.14,1.5,2.15,1.49,2,0h0Z"
        />
        <path
          d="m98.87,161.98c-.1,0-.2-.03-.28-.09-.23-.16-.29-.47-.13-.7.81-1.17,1.6-2.38,2.4-3.59,2.16-3.29,4.4-6.69,7.03-9.56.19-.2.51-.22.71-.03.2.19.22.5.03.71-2.58,2.81-4.79,6.18-6.93,9.44-.8,1.22-1.6,2.43-2.41,3.61-.1.14-.25.22-.41.22Z"
        />
        <path
          d="m96.21,162.22c-.09,0-.17-.02-.25-.07-.24-.14-.32-.45-.18-.69,2.75-4.65,6.96-10.21,9.73-13.56.18-.21.49-.24.7-.07.21.18.24.49.07.7-2.75,3.33-6.92,8.84-9.64,13.44-.09.16-.26.25-.43.25Z"
        />
      </g>
    </g>
    <g
      id="Eyebrow_type_A-8-3-11"
      v-if="data.value === 'type-11' && data.position === 'b'"
    >
      <g :fill="data.color">
        <path
          d="m174.79,162.18l.03-4.55c.03-.32.18-.56.39-.62l27.78-12.77c.21-.05.54-.04.67.03l13.16,6.72c.61.25.48,1.01-.14,1.17l-40.98,10.6c-.41.11-.82-.2-.92-.59Z"
        />
        <path
          d="m174.78,162.13l-1.56-3.98c-.23-.54.57-.95.88-.47,0,0,2.44,3.51,2.44,3.52.81,1.25-1.2,2.31-1.77.93h0Z"
        />
        <path
          d="m172.68,162.68l-1.4-3.66c-.22-.53.56-.95.88-.47,0,0,2.29,3.19,2.29,3.2.83,1.26-1.19,2.33-1.77.94h0Z"
        />
        <path
          d="m219.52,151.35c-.08,0-.16-.02-.23-.06-1.27-.66-2.54-1.35-3.83-2.05-3.42-1.87-6.96-3.79-10.55-5.06-.26-.09-.4-.38-.31-.64.09-.26.38-.39.64-.31,3.67,1.29,7.25,3.24,10.7,5.13,1.28.7,2.55,1.39,3.81,2.04.25.13.34.43.21.67-.09.17-.26.27-.44.27Z"
        />
        <path
          d="m221.98,150.31c-.09,0-.18-.02-.26-.07-4.57-2.78-10.84-5.68-14.83-7.32-.25-.1-.38-.4-.27-.65.1-.26.4-.38.65-.27,4.02,1.66,10.35,4.58,14.97,7.39.24.14.31.45.17.69-.09.15-.26.24-.43.24Z"
        />
        <path
          d="m145.38,162.18l-.03-4.55c-.03-.32-.18-.56-.39-.62l-27.78-12.77c-.21-.05-.54-.04-.67.03l-13.16,6.72c-.61.25-.48,1.01.14,1.17l40.98,10.6c.41.11.82-.2.92-.59Z"
        />
        <path
          d="m145.39,162.13l1.56-3.98c.23-.54-.57-.95-.88-.47,0,0-2.44,3.51-2.44,3.52-.81,1.25,1.2,2.31,1.77.93h0Z"
        />
        <path
          d="m147.49,162.68l1.4-3.66c.22-.53-.56-.95-.88-.47,0,0-2.29,3.19-2.29,3.2-.83,1.26,1.19,2.33,1.77.94h0Z"
        />
        <path
          d="m100.65,151.35c-.18,0-.36-.1-.44-.27-.13-.25-.03-.55.21-.67,1.26-.65,2.53-1.34,3.81-2.04,3.46-1.88,7.03-3.83,10.7-5.13.26-.09.55.04.64.31.09.26-.04.55-.31.64-3.6,1.27-7.13,3.2-10.55,5.06-1.28.7-2.56,1.4-3.83,2.05-.07.04-.15.06-.23.06Z"
        />
        <path
          d="m98.19,150.31c-.17,0-.33-.09-.43-.24-.14-.24-.07-.54.17-.69,4.62-2.8,10.95-5.73,14.97-7.39.26-.11.55.02.65.27.11.26-.02.55-.27.65-3.99,1.64-10.26,4.54-14.83,7.32-.08.05-.17.07-.26.07Z"
        />
      </g>
    </g>
    <g
      id="Eyebrow_type_A-8-3-10"
      v-if="data.value === 'type-10' && data.position === 'b'"
    >
      <g :fill="data.color">
        <path
          d="m172.76,156.5l1.17-4.4c.11-.3.32-.5.53-.5l30.1-5.4c.21,0,.53.1.64.2l11.06,9.8c.53.4.21,1.1-.43,1.1h-42.33c-.43,0-.74-.4-.74-.8Z"
        />
        <path
          d="m172.77,156.45l-.51-4.24c-.09-.58.79-.78.97-.23,0,0,1.48,4.01,1.48,4.01.47,1.41-1.74,1.93-1.95.46h0Z"
        />
        <path
          d="m170.6,156.45l-.44-3.9c-.08-.57.78-.78.97-.24,0,0,1.41,3.67,1.42,3.67.49,1.43-1.74,1.96-1.95.46h0Z"
        />
        <path
          d="m218.91,157.23c-.12,0-.24-.04-.33-.13-1.06-.95-2.12-1.94-3.19-2.94-2.85-2.66-5.79-5.42-8.96-7.55-.23-.15-.29-.46-.14-.69.16-.23.47-.29.69-.14,3.23,2.17,6.21,4.96,9.08,7.65,1.06.99,2.11,1.98,3.17,2.93.21.18.22.5.04.71-.1.11-.24.17-.37.17Z"
        />
        <path
          d="m221.56,156.84c-.13,0-.26-.05-.36-.15-3.72-3.83-9.07-8.21-12.52-10.8-.22-.17-.27-.48-.1-.7s.48-.26.7-.1c3.48,2.61,8.88,7.03,12.64,10.9.19.2.19.51,0,.71-.1.09-.22.14-.35.14Z"
        />
        <path
          d="m147.4,156.5l-1.17-4.4c-.11-.3-.32-.5-.53-.5l-30.1-5.4c-.21,0-.53.1-.64.2l-11.06,9.8c-.53.4-.21,1.1.43,1.1h42.33c.43,0,.74-.4.74-.8Z"
        />
        <path
          d="m147.4,156.45l.51-4.24c.09-.58-.79-.78-.97-.23,0,0-1.48,4.01-1.48,4.01-.47,1.41,1.74,1.93,1.95.46h0Z"
        />
        <path
          d="m149.57,156.45l.44-3.9c.08-.57-.78-.78-.97-.24,0,0-1.41,3.67-1.42,3.67-.49,1.43,1.74,1.96,1.95.46h0Z"
        />
        <path
          d="m101.26,157.23c-.14,0-.27-.06-.37-.17-.18-.21-.17-.52.04-.71,1.06-.95,2.11-1.93,3.17-2.93,2.88-2.69,5.85-5.47,9.08-7.65.23-.15.54-.09.69.14.15.23.09.54-.14.69-3.17,2.13-6.11,4.88-8.96,7.55-1.07,1-2.12,1.99-3.19,2.94-.1.09-.21.13-.33.13Z"
        />
        <path
          d="m98.61,156.84c-.13,0-.25-.05-.35-.14-.2-.19-.2-.51,0-.71,3.76-3.87,9.16-8.29,12.64-10.9.22-.17.53-.12.7.1.17.22.12.53-.1.7-3.45,2.59-8.8,6.97-12.52,10.8-.1.1-.23.15-.36.15Z"
        />
      </g>
    </g>
    <g
      id="Eyebrow_type_A-8-3-1"
      v-if="data.value === 'type-9' && data.position === 'b'"
    >
      <g>
        <g>
          <path
            d="M213.41,145.69c-24.48,3.39-24.12,3.38-39.54,8.41,0,0,.36-4.93,4.86-7.37s19.7-4.23,25.18-4.02c5.48,.21,9.5,2.98,9.5,2.98Z"
            :fill="data.color"
          />
          <path
            d="M105.91,145.69c24.48,3.39,24.12,3.38,39.54,8.41,0,0-.36-4.93-4.86-7.37-4.5-2.45-19.7-4.23-25.18-4.02-5.48,.21-9.5,2.98-9.5,2.98Z"
            :fill="data.color"
          />
        </g>
        <g opacity=".3">
          <path
            d="M213.41,145.69c-24.48,3.39-24.12,3.38-39.54,8.41,0,0,.36-4.93,4.86-7.37s19.7-4.23,25.18-4.02c5.48,.21,9.5,2.98,9.5,2.98Z"
            :fill="data.color"
          />
          <path
            d="M105.91,145.69c24.48,3.39,24.12,3.38,39.54,8.41,0,0-.36-4.93-4.86-7.37-4.5-2.45-19.7-4.23-25.18-4.02-5.48,.21-9.5,2.98-9.5,2.98Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Eyebrow_type_A-8-3-2"
      v-if="data.value === 'type-8' && data.position === 'b'"
    >
      <g>
        <g>
          <path
            d="M219.32,150.45c.48,.13,.77-.54,.37-.85-3.25-2.55-10.98-7.82-21.1-9.57-8.28-1.43-14.47-.3-18.33,1.83-.93,.51-.65,1.84,.4,1.94,6.33,.59,22.46,2.4,38.66,6.66Z"
            :fill="data.color"
          />
          <path
            d="M101.98,150.45c-.48,.13-.77-.54-.37-.85,3.25-2.55,10.98-7.82,21.1-9.57,8.28-1.43,14.47-.3,18.33,1.83,.93,.51,.65,1.84-.4,1.94-6.33,.59-22.46,2.4-38.66,6.66Z"
            :fill="data.color"
          />
        </g>
        <g opacity=".3">
          <path
            d="M219.25,150.52c.48,.13,.77-.54,.37-.85-3.25-2.55-10.98-7.82-21.1-9.57-8.28-1.43-14.47-.3-18.33,1.83-.93,.51-.65,1.84,.4,1.94,6.33,.59,22.46,2.4,38.66,6.66Z"
            :fill="data.color"
          />
          <path
            d="M101.91,150.52c-.48,.13-.77-.54-.37-.85,3.25-2.55,10.98-7.82,21.1-9.57,8.28-1.43,14.47-.3,18.33,1.83,.93,.51,.65,1.84-.4,1.94-6.33,.59-22.46,2.4-38.66,6.66Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Eyebrow_type_A-8-3-3"
      v-if="data.value === 'type-7' && data.position === 'b'"
    >
      <g>
        <g>
          <path
            d="M175.24,152.92s20.24-11.31,42.93,1.87c0,0-4.42-7.08-15.03-10.72-10.61-3.64-23.66,.9-27.91,8.85Z"
            :fill="data.color"
          />
          <path
            d="M144.28,152.92s-20.24-11.31-42.93,1.87c0,0,4.42-7.08,15.03-10.72s23.66,.9,27.91,8.85Z"
            :fill="data.color"
          />
        </g>
        <g opacity=".3">
          <path
            d="M175.24,152.92s20.24-11.31,42.93,1.87c0,0-4.42-7.08-15.03-10.72-10.61-3.64-23.66,.9-27.91,8.85Z"
            :fill="data.color"
          />
          <path
            d="M144.28,152.92s-20.24-11.31-42.93,1.87c0,0,4.42-7.08,15.03-10.72s23.66,.9,27.91,8.85Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Eyebrow_type_A-8-2-1"
      v-if="data.value === 'type-6' && data.position === 'b'"
    >
      <g>
        <g>
          <path
            d="M173.59,154.55s18.9-6.14,42.92-5.99c0,0-6.23-5.22-12.86-6.45,0,0-13.71-.15-22.2,2.46,0,0-5.38,4.92-7.86,9.98Z"
            :fill="data.color"
          />
          <path
            d="M145.03,154.55s-18.9-6.14-42.92-5.99c0,0,6.23-5.22,12.86-6.45,0,0,13.71-.15,22.2,2.46,0,0,5.38,4.92,7.86,9.98Z"
            :fill="data.color"
          />
        </g>
        <g opacity=".3">
          <path
            d="M173.59,154.55s18.9-6.14,42.92-5.99c0,0-6.23-5.22-12.86-6.45,0,0-13.71-.15-22.2,2.46,0,0-5.38,4.92-7.86,9.98Z"
            :fill="data.color"
          />
          <path
            d="M145.03,154.55s-18.9-6.14-42.92-5.99c0,0,6.23-5.22,12.86-6.45,0,0,13.71-.15,22.2,2.46,0,0,5.38,4.92,7.86,9.98Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Eyebrow_type_A-8-2-2"
      v-if="data.value === 'type-5' && data.position === 'b'"
    >
      <g>
        <g>
          <path
            d="M180.33,147.48c.54-3.74,14.49-6.46,20.18-4.96,.79,.21,3.01,.81,4.18,1.81,.88,.75,1.82,1.68,1.63,3.1-.27,2.08-3.07,3.12-3.86,3.45-1.59,.67-4.99,.68-8.16,.52s-14.31-1.57-13.97-3.93Z"
            :fill="data.color"
          />
          <path
            d="M139.19,147.48c-.54-3.74-14.49-6.46-20.18-4.96-.79,.21-3.01,.81-4.18,1.81-.88,.75-1.82,1.68-1.63,3.1,.27,2.08,3.07,3.12,3.86,3.45,1.59,.67,4.99,.68,8.16,.52s14.31-1.57,13.97-3.93Z"
            :fill="data.color"
          />
        </g>
        <g opacity=".3">
          <path
            d="M180.33,147.48c.54-3.74,14.49-6.46,20.18-4.96,.79,.21,3.01,.81,4.18,1.81,.88,.75,1.82,1.68,1.63,3.1-.27,2.08-3.07,3.12-3.86,3.45-1.59,.67-4.99,.68-8.16,.52s-14.31-1.57-13.97-3.93Z"
            :fill="data.color"
          />
          <path
            d="M139.19,147.48c-.54-3.74-14.49-6.46-20.18-4.96-.79,.21-3.01,.81-4.18,1.81-.88,.75-1.82,1.68-1.63,3.1,.27,2.08,3.07,3.12,3.86,3.45,1.59,.67,4.99,.68,8.16,.52s14.31-1.57,13.97-3.93Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Eyebrow_type_A-8-2-3"
      v-if="data.value === 'type-4' && data.position === 'b'"
    >
      <g>
        <g>
          <path
            d="M216.96,150.97s-9.99-3.2-18.45-2.88-18.21,2.97-20.28,2.35c-2.08-.61-3.7-5.27,3.22-7.81,5.56-2.65,24.59-3.99,35.51,8.33Z"
            :fill="data.color"
          />
          <path
            d="M102.57,150.97s9.99-3.2,18.45-2.88c8.46,.32,18.21,2.97,20.28,2.35s3.7-5.27-3.22-7.81c-5.56-2.65-24.59-3.99-35.51,8.33Z"
            :fill="data.color"
          />
        </g>
        <g opacity=".3">
          <path
            d="M216.96,150.97s-9.99-3.2-18.45-2.88-18.21,2.97-20.28,2.35c-2.08-.61-3.7-5.27,3.22-7.81,5.56-2.65,24.59-3.99,35.51,8.33Z"
            :fill="data.color"
          />
          <path
            d="M102.57,150.97s9.99-3.2,18.45-2.88c8.46,.32,18.21,2.97,20.28,2.35s3.7-5.27-3.22-7.81c-5.56-2.65-24.59-3.99-35.51,8.33Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Eyebrow_type_A-8-1-1"
      v-if="data.value === 'type-3' && data.position === 'b'"
    >
      <g>
        <g>
          <path
            d="M175.74,154.8s2.77-9.73,10.02-15.08c0,0,12.77-2.61,30.47,2.22,0,0-32.02,10.83-40.48,12.86Z"
            :fill="data.color"
          />
          <path
            d="M143.78,154.8s-2.77-9.73-10.02-15.08c0,0-12.77-2.61-30.47,2.22,0,0,32.02,10.83,40.48,12.86Z"
            :fill="data.color"
          />
        </g>
        <g opacity=".3">
          <path
            d="M175.74,154.8s2.77-9.73,10.02-15.08c0,0,12.77-2.61,30.47,2.22,0,0-32.02,10.83-40.48,12.86Z"
            :fill="data.color"
          />
          <path
            d="M143.78,154.8s-2.77-9.73-10.02-15.08c0,0-12.77-2.61-30.47,2.22,0,0,32.02,10.83,40.48,12.86Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Eyebrow_type_A-8-1-2"
      v-if="data.value === 'type-2' && data.position === 'b'"
    >
      <g>
        <g>
          <path
            d="M178.04,142.77s-2.01,3.74-3.11,9.82c0,0-.29,.85,1.22,.65s12.77-4.66,25.04-5.55c0,0,10.86,.79,18.75,4.68,0,0-7.32-11.33-20.6-14.39,0,0-8.65-1.22-21.31,4.79Z"
            :fill="data.color"
          />
          <path
            d="M141.56,142.77s2.01,3.74,3.11,9.82c0,0,.29,.85-1.22,.65s-12.77-4.66-25.04-5.55c0,0-10.86,.79-18.75,4.68,0,0,7.32-11.33,20.6-14.39,0,0,8.65-1.22,21.31,4.79Z"
            :fill="data.color"
          />
        </g>
        <g opacity=".3">
          <path
            d="M178.04,142.77s-2.01,3.74-3.11,9.82c0,0-.29,.85,1.22,.65s12.77-4.66,25.04-5.55c0,0,10.86,.79,18.75,4.68,0,0-7.32-11.33-20.6-14.39,0,0-8.65-1.22-21.31,4.79Z"
            :fill="data.color"
          />
          <path
            d="M141.56,142.77s2.01,3.74,3.11,9.82c0,0,.29,.85-1.22,.65s-12.77-4.66-25.04-5.55c0,0-10.86,.79-18.75,4.68,0,0,7.32-11.33,20.6-14.39,0,0,8.65-1.22,21.31,4.79Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Eyebrow_type_A-8-1-3"
      v-if="data.value === 'type-1' && data.position === 'b'"
    >
      <g>
        <g>
          <path
            d="M174.19,149.21s2.4,2.36,4.4,3.56c0,0,17.59-4.37,40.39-3.53,.2,.24-9.4-10.84-14.99-14.22,0,0-14.19,3.08-29.79,14.19Z"
            :fill="data.color"
          />
          <path
            d="M145.41,149.21s-2.4,2.36-4.4,3.56c0,0-17.59-4.37-40.39-3.53-.2,.24,9.4-10.84,14.99-14.22,0,0,14.19,3.08,29.79,14.19Z"
            :fill="data.color"
          />
        </g>
        <g opacity=".3">
          <path
            d="M174.19,149.21s2.4,2.36,4.4,3.56c0,0,17.59-4.37,40.39-3.53,.2,.24-9.4-10.84-14.99-14.22,0,0-14.19,3.08-29.79,14.19Z"
            :fill="data.color"
          />
          <path
            d="M145.41,149.21s-2.4,2.36-4.4,3.56c0,0-17.59-4.37-40.39-3.53-.2,.24,9.4-10.84,14.99-14.22,0,0,14.19,3.08,29.79,14.19Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
  </fragment>
</template>

<script>
export default {
  name: 'avatarEyebrowA',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
